import { render } from "./CopyrightFooter.vue?vue&type=template&id=2ce1a0a8&scoped=true"
import script from "./CopyrightFooter.vue?vue&type=script&lang=js"
export * from "./CopyrightFooter.vue?vue&type=script&lang=js"

import "./CopyrightFooter.vue?vue&type=style&index=0&id=2ce1a0a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce1a0a8"]])

export default __exports__